// extracted by mini-css-extract-plugin
export default {"container":"advantage-card_container__Hb2RN","heading":"advantage-card_heading__qEikw","message":"advantage-card_message__LM6f-","first":"advantage-card_first__mdIZF"};